import apiClient from '../api.js';

const resource = '/estudiante';

/**
 * Cuenta de acceso del estudiante al sistema.
 *
 * Son dos cosas distintas: los datos personales (unicen.estudiante) y el usuario
 * con el que entra (unicen.usuarioest). Hay estudiantes cargados sin usuario, y
 * para esos la contraseña no sirve hasta que el usuario exista.
 *
 * El restablecimiento no manda ninguna contraseña: el backend la deja siempre en
 * el md5 del numero de documento del propio estudiante, asi que desde aca solo
 * se identifica a quien se le restablece.
 */
const useEstudianteCuentaApi = {
    /**
     * Estado del usuario de acceso. Responde `NotFount` cuando no existe.
     * @param {string|number} unicodigo Unicodigo del estudiante.
     * @param {string|number} id_sede   Sede desde la que se consulta.
     */
    verificarUsuario(unicodigo, id_sede) {
        return apiClient.get(`${resource}/usuario/${unicodigo},${id_sede}`);
    },

    /** Crea el usuario faltante con el rol ESTUDIANTE de la sede. */
    crearUsuario(unicodigo, id_sede) {
        return apiClient.post(`${resource}/usuario/${unicodigo},${id_sede}`);
    },

    /** @param {string|number} unicodigo Unicodigo del estudiante. */
    resetearPassword(unicodigo) {
        return apiClient.put(`${resource}/resetearpass/${unicodigo}`);
    },
};

export default useEstudianteCuentaApi;
